import { CommunityDashboardResponse } from "../models/CommunityDashboard";
import apiClient from "./api-client";

const COMMUNITY_BASE_URL = "/analytics/community";

export const getCommunityDashboard = async (): Promise<CommunityDashboardResponse> => {
	const response = await apiClient.get<CommunityDashboardResponse>(COMMUNITY_BASE_URL);
	return response.data;
};
